import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SolicitudResumidasModel } from 'src/app/models/credits-application/solicitud.model';

@Component({
  selector: 'app-solicitud-datos-temporales',
  templateUrl: './solicitud-datos-temporales.component.html',
  styleUrls: ['./solicitud-datos-temporales.component.scss']
})
export class SolicitudDatosTemporalesComponent implements OnChanges {

  // PARAMETROS RECIBIDOS
  @Input() solicitudesDatosTemporales: SolicitudResumidasModel[];

  constructor(
    private router: Router,
  ) { }

  ngOnChanges(): void {}

  // METODOS HTML
  visualizarSolicitud(solicitud: SolicitudResumidasModel) {

    const route = '/capturar-documentos';
    this.router.navigate([route], {
      queryParams: {
        numSolicitud: solicitud.numSolicitud,
        claveEstatusSolicitud: solicitud.estatus.clave,
        claveTipoSolicitud: solicitud.tipoSolicitud.clave
      }
    });
  }
}
